import { doc, UpdateData, updateDoc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import { INumber } from "@leedpulse-monorepo/interfaces";
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { cleanPhoneNumber } from '@leedpulse-monorepo/utils';

async function updateNumber(
  number: INumber,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdateNumberFailure("Unauthorized", "unauthorized");
  }
  try {
    
    if (number.group_name === '' || number.group_id === '') {
      throw new UpdateNumberFailure('Les informations renseignées sont incomplètes');
    }

    const { ai_receptionist, ...numberFields } = number;

    const numberPatch: UpdateData<INumber> = {
      ...Object.fromEntries(Object.entries(numberFields).filter(([, value]) => value !== undefined)),
      // Dotted paths: the form only holds some ai_receptionist fields, the ones
      // set from the app (ring_count, triggers...) must survive a backoffice save.
      ...Object.fromEntries(
        Object.entries(ai_receptionist ?? {})
          .filter(([, value]) => value !== undefined)
          .map(([key, value]) => [`ai_receptionist.${key}`, value])
      ),
      updated: Date.now(),
    };

    if (number.redirection !== undefined) {
      numberPatch.redirection = cleanPhoneNumber(number.redirection || '');
    }

    const db = firestore;

    await updateDoc(
      doc(db, FirestoreCollections.numbers, number.group_id),
      numberPatch
    );

    return;
  } catch (e) {
    console.log("error: ", e);
    throw new UpdateNumberFailure();
  }
}

export class UpdateNumberFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default updateNumber;
